import { Injectable } from "@angular/core";
import { TranslateDefaultParser } from "@ngx-translate/core";

@Injectable()
export class TranslateNfonParser extends TranslateDefaultParser {
  public getValue(target: any, key: string): any {
    const defaultParserValue: any = target[key];

    // treat empty string as missing translation key forcing fallback to default
    return defaultParserValue === "" ? undefined : defaultParserValue;
  }
}
